import type { UserProfile } from '../types/schema'
import { DEFAULT_AVATAR_ID, getAvatarById } from './cosmeticCatalog'

export type ProfileImageSource = 'GOOGLE' | 'AVATAR'

export type ProfileImagePreference = {
  source?: ProfileImageSource | null
  avatarId?: string | null
}

export type ProfileImageSubject = {
  photoURL?: string | null
  profileImage?: ProfileImagePreference | Record<string, unknown> | null
}

const avatarSvgCache = new Map<string, string>()

export const avatarImageDataUrl = (avatarId: string): string => {
  const avatar = getAvatarById(avatarId) ?? getAvatarById(DEFAULT_AVATAR_ID)
  const cacheKey = avatar?.id ?? DEFAULT_AVATAR_ID
  const cached = avatarSvgCache.get(cacheKey)
  if (cached) return cached
  const emoji = avatar?.emoji ?? '✦'
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 96"><defs><radialGradient id="g" cx="35%" cy="25%" r="80%"><stop offset="0" stop-color="#67e8f9"/><stop offset="0.46" stop-color="#6366f1"/><stop offset="1" stop-color="#020617"/></radialGradient></defs><rect width="96" height="96" rx="48" fill="url(#g)"/><circle cx="48" cy="48" r="42" fill="none" stroke="rgba(255,255,255,.28)" stroke-width="2"/><text x="48" y="58" text-anchor="middle" font-size="44" font-family="Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif">${emoji}</text></svg>`
  const dataUrl = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`
  avatarSvgCache.set(cacheKey, dataUrl)
  return dataUrl
}

export const resolveProfileImageUrl = (
  profile?: ProfileImageSubject | Partial<UserProfile> | Record<string, unknown> | null,
  authUser?: { photoURL?: string | null } | null,
): string => {
  const preference = profile?.profileImage && typeof profile.profileImage === 'object'
    ? profile.profileImage as ProfileImagePreference
    : null
  const profilePhoto = typeof profile?.photoURL === 'string' ? profile.photoURL : ''
  const authPhoto = typeof authUser?.photoURL === 'string' ? authUser.photoURL : ''
  if (preference?.source === 'AVATAR') return avatarImageDataUrl(preference.avatarId || DEFAULT_AVATAR_ID)
  if (preference?.source === 'GOOGLE') return profilePhoto || authPhoto
  return profilePhoto || authPhoto
}
